import {combineReducers, createStore} from "redux";
import userIdReducer from "../reducers/userIdReducer";
import screenNameReducer from "../reducers/screenNameReducer";
import serviceReducer from "../reducers/serviceReducer";
import adminMenuItemsReducer from "../reducers/adminMenuItemsReducer";
import adminDataReducer from "../reducers/adminDataReducer";
import DashboardReducer from "../reducers/DashboardReducer";
import wordsReducer from "../reducers/wordsReducer";
import abuseScanReducers from "../reducers/abuseScanReducers";
import adminAppealReducer from "../reducers/adminAppealReducer";
import allFormsReducer from "../reducers/allFormsReducer";
import testingToolsReducer from "../reducers/testingToolsReducer";
import adminReportReducer from "../reducers/adminReportReducer";
import adminDetailsReducer from "../reducers/adminDetailsReducer";
import inAppMessagesReducer from "../reducers/inAppMessagesReducer";
import adminFaqReducer from "../reducers/adminFaqReducer";


const newAdminStore = createStore(combineReducers({
    wordsReducer,
    userIdReducer,
    serviceReducer,
    allFormsReducer,
    adminDataReducer,
    DashboardReducer,
    abuseScanReducers,
    screenNameReducer,
    adminAppealReducer,
    adminReportReducer,
    testingToolsReducer,
    adminMenuItemsReducer,
    adminDetailsReducer,
    adminFaqReducer,
    inAppMessagesReducer,
}), process.env.REACT_APP_ENV_IS_REACT_DEV_TOOLS === "true" ? (window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) : undefined);

export default newAdminStore;
